import React from 'react';
import { Building2, Key, HandCoins, Wrench, ArrowRight } from 'lucide-react';
import { services, referenceNote } from '../../data/mock';

const iconMap = {
  Building2,
  Key,
  HandCoins,
  Wrench
};

const Services = () => {
  return (
    <section id="services" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
            Unsere Leistungen
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6">
            Umfassende Dienstleistungen für Ihre Immobilie
          </h2>
          <p className="text-lg text-slate-600">
            Wir bieten Ihnen ein breites Spektrum an professionellen Dienstleistungen
            rund um Ihre Immobilie – alles aus einer Hand.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-slate-50 rounded-2xl p-8 hover:bg-teal-600 transition-all duration-500 hover:shadow-xl hover:shadow-teal-600/20 hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-teal-100 group-hover:bg-white/20 rounded-xl flex items-center justify-center mb-6 transition-colors duration-500">
                  <IconComponent className="w-7 h-7 text-teal-600 group-hover:text-white transition-colors duration-500" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 group-hover:text-white mb-3 transition-colors duration-500">
                  {service.title}
                </h3>
                <p className="text-slate-600 group-hover:text-white/90 leading-relaxed transition-colors duration-500">
                  {service.description}
                </p>

                {/* Hover Arrow */}
                <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <ArrowRight className="w-6 h-6 text-white" />
                </div>

                {/* Number Badge */}
                <span className="absolute top-6 right-6 text-6xl font-bold text-slate-200 group-hover:text-white/10 transition-colors duration-500">
                  {index + 1}
                </span>
              </div>
            );
          })}
        </div>

        {/* Reference Note */}
        <div className="mt-12 text-center">
          <p className="text-slate-500 italic">
            {referenceNote}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
